import styled from '@emotion/styled';
import { FaqIcon, GraphOutlineIcon } from '@seedlang/icons';
import { AppUI } from '@seedlang/state';
import HeaderBar from 'components/header_bar';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { observer } from 'mobx-react';
import React from 'react';
import { Outlet } from 'react-router-dom';

const Wrapper = styled.div`
`;

const Content = styled.div`
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${props => props.padding};
`;

@observer
class Review extends React.Component {

  constructor(props) {
    super(props);
    AppUI.loadUser();
    AppUI.createEvent('reviews - view page');
  }

  render() {
    return (
      <Wrapper>
        <HeaderBar
          title={`${AppUI.targetLanguageName} REVIEWS`}
          titleRoute='reviews.home'
          lookupPage
          pageInfo={[
            {
              route: 'reviews.progress',
              current: 'Progress',
            },
            {
              route: 'reviews.show',
              current: 'Review Details',
              breadcrumbs: [['reviews.index', 'Reviews List']],
              lookupPage: true,
            },
          ]}
          icons={[
            {
              icon: <FaqIcon />,
              tooltipText: 'Help Center',
              iconRoute: 'faq_categories.show',
              iconParams: {faqCategoryId: '7d2bdc2a-34ec-414a-971c-afb00c9291a5'},
            },
            {
              icon: <GraphOutlineIcon />,
              tooltipText: 'View Progress',
              iconRoute: 'reviews.progress',
              breadcrumb: 'Progress',
            },
          ]}
        />
        <Content>
          <Outlet />
        </Content>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(Review);
